import { mappedContractId, walkPlan } from '@timelog/pm-shared';
import type { PlanNode } from '@timelog/pm-shared';

/**
 * The contracts a parent task's subtasks map to (3 Nov, Mette: a parent shows
 * the Contract insights of all its children). A parent maps nothing itself
 * (ADR 0033) — its leaves each name their own — so this collects the leaves'
 * contracts, in `order` (the Financials order), each once. Iterative, like
 * every plan walk (BR-3).
 */
export const subtreeContractIds = (node: PlanNode, order: readonly string[]): string[] => {
  const found = new Set<string>();
  walkPlan(node.children, (child) => {
    if (child.children.length > 0) return;
    const id = mappedContractId(child);
    if (id !== undefined) found.add(id);
  });
  return order.filter((id) => found.has(id));
};
